import { openSnackbar } from "api/snackbar";
import { SnackbarProps } from "types/snackbar";

export function showSuccess(
  message: string,
  autoHideDuration?: number,
  v?: string,
  h?: string
) {
  openSnackbar({
    open: true,
    message: message,
    autoHideDuration: autoHideDuration,
    anchorOrigin: { vertical: v ?? "top", horizontal: h ?? "right" },
    variant: "alert",
    alert: {
      color: "success",
    },
  } as SnackbarProps);
}

export function showError(
  message: string,
  autoHideDuration?: number,
  v?: string,
  h?: string
) {
  openSnackbar({
    open: true,
    message: message,
    autoHideDuration: autoHideDuration,
    anchorOrigin: { vertical: v ?? "top", horizontal: h ?? "right" },
    variant: "alert",
    alert: {
      color: "error",
    },
  } as SnackbarProps);
}
